export default function ExportIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="#006BB7"
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <polyline
        points="216 100 216 40 156 40"
        fill="none"
        stroke="#006BB7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="20"
      ></polyline>
      <line
        x1="144"
        y1="112"
        x2="216"
        y2="40"
        fill="none"
        stroke="#006BB7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="20"
      ></line>
      <path
        d="M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64"
        fill="none"
        stroke="#006BB7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="20"
      ></path>
    </svg>
  );
}
